import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'

type ConfirmationDialogProps = {
  title: string
  content: JSX.Element
  onConfirm: () => void
  triggerTestId?: string
  cancelTestId?: string
  confirmTestId?: string
  dialogTestId?: string
}

const ConfirmationDialog = ({
  title,
  content,
  onConfirm,
  triggerTestId,
  cancelTestId,
  confirmTestId,
  dialogTestId,
}: ConfirmationDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button data-testid={triggerTestId} color="error" onClick={() => setDialogOpen(true)}>
        {content}
      </Button>
      <Dialog data-testid={dialogTestId} open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Confirm your action</DialogTitle>
        <DialogContent>
          <DialogContentText>{title}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button data-testid={cancelTestId} onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button data-testid={confirmTestId} onClick={onConfirm} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ConfirmationDialog
